import { IsNumber, IsOptional, IsString } from 'class-validator';

export class TreasuryFullModuleOverviewRequestDto {
  @IsNumber()
  businessEntityId: number;

  @IsString()
  @IsOptional()
  weekDate?: Date | string;
}
